
const get = (key: string, jsonParse = true) => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const data = window.localStorage.getItem(key);

    return data ? (jsonParse ? JSON.parse(data) : data) : undefined;
  } catch (error) {
    return null;
  }
};

const set = (key: string, value: any) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(key, JSON.stringify(value));
};

const remove = (key: string) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.removeItem(key);
};

export const LocalStorage = {
  get,
  set,
  remove,
};
